"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const models_1 = require("@completeanatomy/models");
const ui_1 = require("@completeanatomy/ui");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importStar(require("styled-components"));
function ModelSexOverlay({ isShown }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const modelType = (0, models_1.useModelType)();
    const isMale = modelType === bridge_schema_1.ModelType.Male;
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isShown, timeout: 200, mountOnEnter: true, unmountOnExit: true, "data-e2e": 'ModelSexOverlay_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Overlay, { "data-e2e": 'ModelSexOverlay_Overlay', children: [(0, jsx_runtime_1.jsx)(OverlayTitle, { "data-e2e": 'ModelSexOverlay_OverlayTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.model.sex) }), (0, jsx_runtime_1.jsxs)(SubtitleContainer, { "data-e2e": 'ModelSexOverlay_SubtitleContainer', children: [(0, jsx_runtime_1.jsx)(Subtitle, { "data-e2e": 'ModelSexOverlay_Subtitle', children: isMale
                                ? (0, i18n_1.Localized)(i18n_1.Strings.model.male)
                                : (0, i18n_1.Localized)(i18n_1.Strings.model.female) }), isMobile ? ((0, jsx_runtime_1.jsx)(SexIcon, { name: isMale ? ui_1.Icons.Male_Overlay_Mobile : ui_1.Icons.Female_Overlay_Mobile, style: { width: 32, height: 32 }, "data-e2e": 'ModelSexOverlay_SexIcon' })) : ((0, jsx_runtime_1.jsx)(SexIcon, { name: isMale ? ui_1.Icons.Male_Overlay : ui_1.Icons.Female_Overlay, style: { width: 40, height: 40 }, "data-e2e": 'ModelSexOverlay_SexIcon' }))] })] }) }));
}
exports.default = ModelSexOverlay;
const Overlay = styled_components_1.default.div `
  position: absolute;

  bottom: 110px;

  left: 16px;

  display: flex;

  flex-direction: column;

  width: 250px;

  pointer-events: none;

  ${ui_1.deviceLandscape.mobileS((0, styled_components_1.css) `
    left: 32px;
    bottom: 98px;
  `)}

  ${ui_1.device.laptopS((0, styled_components_1.css) `
    left: 40px;
    bottom: 112px;
  `)}
`;
const OverlayTitle = styled_components_1.default.div `
  color: #ffffff;
  font-size: 40px;
  text-align: left;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
`;
const SubtitleContainer = styled_components_1.default.div `
  display: flex;
`;
const Subtitle = styled_components_1.default.div `
  color: #ffffff;
  font-weight: bold;
  font-size: 60px;
  text-align: left;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.4);
`;
const SexIcon = (0, styled_components_1.default)(ui_1.Icon) `
  position: relative;
  top: 20px;
  left: 10px;

  color: ${({ theme }) => theme.textSecondary};
`;
